// Small per-browser conveniences (theme, collapsed groups, last backup time).
// Never used for roadmap data, which lives in IndexedDB.
const PREFIX = 'minnimap:';

export function readPref(key, fallback = null) {
  try {
    const raw = window.localStorage.getItem(PREFIX + key);
    return raw === null ? fallback : JSON.parse(raw);
  } catch {
    return fallback;
  }
}

export function writePref(key, value) {
  try {
    if (value === null || value === undefined) window.localStorage.removeItem(PREFIX + key);
    else window.localStorage.setItem(PREFIX + key, JSON.stringify(value));
  } catch {
    /* storage blocked; the preference just will not stick */
  }
}
